import CrystalBall from './CrystalBall'

export default CrystalBall
// eslint-disable-next-line import/export
export * from './CrystalBall'
